'use strict';

angular.module('enervexSalesappApp').controller('GlobalHubspotDealsCtrl', function(Auth, $scope, GlobalHubspotDeal, Flash, Util) {
	// matches MAX_ROWS in server/api/global-hubspot-deal/controller.js
	var MAX_ROWS = 5000;

	/**
	 * Presentation only -- the API enforces canSynchHubspot on the route. A
	 * function, not a cached value, because the session may not have resolved when
	 * the controller runs.
	 */
	$scope.canSynchHubspot = function() {
		return Auth.hasUserPermissionStrict('canSynchHubspot');
	};
	$scope.jobLabel = Util.jobLabel;
	$scope.isAdmin = Auth.isAdmin;
	$scope.accessAllAccounts = Auth.accessAllAccounts;
	$scope.ctx = {
		startedAt: moment().subtract(parseInt(1), 'weeks').toDate(),
		endedAt: moment().add(parseInt(1), 'day').toDate()
	};

	function fetch() {
		Flash.clear();
		Flash.create('info', '<strong>Searching</strong> HubSpot deals....', 0, {}, true);
		GlobalHubspotDeal.query({
			startedAt: moment($scope.ctx.startedAt).toISOString(),
			endedAt: moment($scope.ctx.endedAt).toISOString()
		}).$promise.then(function(deals) {
			Flash.clear();
			if (deals.length >= MAX_ROWS) {
				Flash.create('warning', '<strong>Search</strong> Showing the first ' + deals.length +
					" HubSpot deals. Narrow the date range to see the rest.", 0, {}, true);
			} else {
				Flash.create('info', '<strong>Search</strong> Found ' + deals.length + " HubSpot deals", 0, {}, true);
			}
			$scope.deals = deals;
		}).catch(function(err) {
			Flash.clear();
			var message = (err && err.data && err.data.message) ? err.data.message : 'Could not load HubSpot deals.';
			Flash.create('danger', '<strong>Error</strong> ' + message, 0, {}, true);
		});
	}
	fetch();

	$scope.limit = 5;
	$scope.removeLimit = function() {
		$scope.showAll = true;
		$scope.limit = $scope.deals.length;
	};
	$scope.placeLimit = function() {
		$scope.showAll = false;
		$scope.limit = 5;
	};
	$scope.change = function(topLevel) {
		if (!topLevel) {
			return;
		}
		fetch();
	};

	/**
	 * The total this deal last pushed to HubSpot -- what the pipeline actually
	 * holds, not a figure recomputed here.
	 */
	$scope.dealAmount = function(deal) {
		return (deal && deal.amount != null) ? deal.amount : null;
	};
});
